<div class="container-price">
  <div class="head">
    <h1>
      {{ plan?.title || "Plano" }}

      <img *ngIf="!plan?.free" src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/ico-banner-pro.png" alt="" />
      <img *ngIf="plan?.free" src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/svg/icon-free-rounded.svg" alt="" />
    </h1>

    <p [innerHTML]="plan?.subtitle || 'Esse plano contém erros...'"></p>

    <ng-container *ngIf="!ispro">
      <button
        class="unh-button-old"
        theme="pink-white"
        *ngIf="!plan?.free"
        mat-button
        [innerHTML]="plan?.btnText"
        (click)="actionClicked.emit(plan)"
      ></button>

      <button
        class="unh-button-old"
        theme="blue-white"
        *ngIf="plan?.free"
        mat-button
        [innerHTML]="plan?.btnText"
        (click)="actionClicked.emit(plan)"
      ></button>
    </ng-container>
  </div>
</div>
